interface Props {
  size?: number;
  className?: string;
}

export default function TengeRecive({ size = 16, className }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <path
        d="M7.99992 15.1667C4.04659 15.1667 0.833252 11.9534 0.833252 8.00004C0.833252 4.04671 4.04659 0.833374 7.99992 0.833374C8.27325 0.833374 8.49992 1.06004 8.49992 1.33337C8.49992 1.60671 8.27325 1.83337 7.99992 1.83337C4.59992 1.83337 1.83325 4.60004 1.83325 8.00004C1.83325 11.4 4.59992 14.1667 7.99992 14.1667C11.3999 14.1667 14.1666 11.4 14.1666 8.00004C14.1666 7.72671 14.3933 7.50004 14.6666 7.50004C14.9399 7.50004 15.1666 7.72671 15.1666 8.00004C15.1666 11.9534 11.9533 15.1667 7.99992 15.1667Z"
        fill="currentColor"
      />
      <path
        d="M7.49797 11.3333V8.27799H5.3313C5.05523 8.27799 4.83142 8.05404 4.8313 7.77799C4.8313 7.50185 5.05516 7.27799 5.3313 7.27799H10.6646C10.9408 7.27799 11.1646 7.50185 11.1646 7.77799C11.1645 8.05404 10.9407 8.27799 10.6646 8.27799H8.49797V11.3333C8.49797 11.6095 8.27411 11.8333 7.99797 11.8333C7.72182 11.8333 7.49797 11.6095 7.49797 11.3333ZM10.6646 5.5C10.9408 5.5 11.1646 5.72386 11.1646 6C11.1646 6.27614 10.9408 6.5 10.6646 6.5H5.3313C5.05516 6.5 4.8313 6.27614 4.8313 6C4.8313 5.72386 5.05516 5.5 5.3313 5.5H10.6646Z"
        fill="currentColor"
      />
      <path
        d="M13.9999 5.16667H11.3333C11.0599 5.16667 10.8333 4.94 10.8333 4.66667V2C10.8333 1.72667 11.0599 1.5 11.3333 1.5C11.6066 1.5 11.8333 1.72667 11.8333 2V4.16667H13.9999C14.2733 4.16667 14.4999 4.39333 14.4999 4.66667C14.4999 4.94 14.2733 5.16667 13.9999 5.16667Z"
        fill="currentColor"
      />
      <path
        d="M11.3333 5.16663C11.2066 5.16663 11.08 5.11996 10.98 5.01996C10.7866 4.82663 10.7866 4.50663 10.98 4.31329L14.3133 0.979961C14.5066 0.786628 14.8266 0.786628 15.02 0.979961C15.2133 1.17329 15.2133 1.49329 15.02 1.68663L11.6866 5.01996C11.5866 5.11996 11.46 5.16663 11.3333 5.16663Z"
        fill="currentColor"
      />
    </svg>
  );
}
